import React from 'react';
import Hero from './Hero';
import AboutMe from './AboutMe';

function App() {
  return (
    <div className="App">
      <Hero />
      <AboutMe />
    </div>
  );
}

export default App;
